"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
var e = require("react"),
  t = require("prop-types"),
  n = require("./grid-965d799c.js"),
  a = require("./credentialCardContent-5610706c.js"),
  l = require("./typography-fb2881fe.js"),
  r = require("./link-8b1ebef7.js");
function i(e) {
  return e && "object" == _typeof(e) && "default" in e ? e : {
    "default": e
  };
}
var o = i(e),
  d = i(t);
function u(e) {
  return !(!e && null === e || void 0 === e || "" === e) && o["default"].createElement("sup", null, e);
}
var s = {
    amBestCompany: function amBestCompany(e) {
      return {
        credentialLogo: null,
        descriptionText: o["default"].createElement(o["default"].Fragment, null, o["default"].createElement(l.TypographyComponent, {
          component: "span",
          uppercase: !0,
          block: !0,
          disableBottomPadding: !0,
          className: "nmx-block"
        }, "Highest"), o["default"].createElement(l.TypographyComponent, {
          component: "span",
          block: !0,
          disableBottomPadding: !0,
          className: "nmx-block"
        }, "A.M. Best Company", u(e)), o["default"].createElement(l.TypographyComponent, {
          component: "span",
          block: !0,
          disableBottomPadding: !0,
          className: "nmx-block"
        }, "October 2024")),
        footerText: o["default"].createElement(o["default"].Fragment, null, o["default"].createElement("cite", null, "August 2023")),
        headingText: o["default"].createElement(o["default"].Fragment, null, "A++"),
        headingTextAriaLabel: "Highest A.M. Best Company rating",
        headingTextAssistiveSupplement: o["default"].createElement(o["default"].Fragment, null, " A.M. Best Company rating"),
        isCitable: !0
      };
    },
    blackFounderAcceleratorProgram: function blackFounderAcceleratorProgram() {
      return {
        credentialLogo: null,
        descriptionText: o["default"].createElement(o["default"].Fragment, null, "Northwestern Mutual Black Founder Accelerator program is working with start-ups in partnership with gener8tor (a nationally ranked start-up accelerator) to provide each Black founder a $100,000 grant to apply toward their business model—along with mentoring from key leaders of Northwestern Mutual.", " ", o["default"].createElement(r.LinkComponent, {
          id: "commitment-to-social-impact-black-founder-accelerator-program-link",
          variant: "primaryDeemphasize",
          linkUrl: "https://news.northwesternmutual.com/2020-11-18-Northwestern-Mutual-Dedicates-20-Million-to-Advance-Black-Entrepreneurs-through-Venture-Capital-a-New-Startup-Accelerator",
          isOutgoingLink: !0
        }, "Learn more about this program.")),
        footerText: null,
        headingText: o["default"].createElement(o["default"].Fragment, null, "$100K"),
        headingTextAriaLabel: "One hundred thousand dollars in grant money provided to each black founder.",
        headingTextAssistiveSupplement: o["default"].createElement(o["default"].Fragment, null, " dollars in grant money provided to each black founder."),
        isCitable: !1
      };
    },
    blackImpactInvestingFund: function blackImpactInvestingFund() {
      return {
        credentialLogo: null,
        descriptionText: o["default"].createElement(o["default"].Fragment, null, "Northwestern Mutual Impact Investing Fund is supporting Black and African-American financial inclusion and economic prosperity with $100 million in funding."),
        footerText: null,
        headingText: o["default"].createElement(o["default"].Fragment, null, "$100M"),
        headingTextAriaLabel: "One hundred million dollars in funding.",
        headingTextAssistiveSupplement: o["default"].createElement(o["default"].Fragment, null, " in funding."),
        isCitable: !1
      };
    },
    blackStartStartUpCompanyDonations: function blackStartStartUpCompanyDonations() {
      return {
        credentialLogo: null,
        descriptionText: o["default"].createElement(o["default"].Fragment, null, "Northwestern Mutual Future Ventures funds has allocated $20 million to start-ups with Black or African-American founders. We have begun investing in companies and are engaged in discussions with others to be part of this initiative.", " ", o["default"].createElement(r.LinkComponent, {
          id: "commitment-to-social-impact-venture-funds-link",
          variant: "primaryDeemphasize",
          linkUrl: "https://news.northwesternmutual.com/2020-11-18-Northwestern-Mutual-Dedicates-20-Million-to-Advance-Black-Entrepreneurs-through-Venture-Capital-a-New-Startup-Accelerator",
          target: "_blank"
        }, "See more details"), "."),
        footerText: null,
        headingText: o["default"].createElement(o["default"].Fragment, null, "$20M"),
        headingTextAriaLabel: "Twenty million dollars allocated to start&#45;ups with Black or African&#45;American founders by Northwestern Mutual Future Ventures funds.",
        headingTextAssistiveSupplement: o["default"].createElement(o["default"].Fragment, null, " dollars allocated to start-ups with Black or African-American founders by Northwestern Mutual Future Ventures funds."),
        isCitable: !1
      };
    },
    childhoodCancerDonations: function childhoodCancerDonations() {
      return {
        credentialLogo: null,
        descriptionText: o["default"].createElement(o["default"].Fragment, null, "donated to fight childhood cancer and support children and families since 2012"),
        footerText: null,
        headingText: o["default"].createElement(o["default"].Fragment, null, "$50M+"),
        headingTextAriaLabel: "More than fifty million dollars donated to fight childhood cancer and support children and families since 2012",
        headingTextAssistiveSupplement: o["default"].createElement(o["default"].Fragment, null, " donated to fight childhood cancer and support children and families since 2012"),
        isCitable: !1
      };
    },
    childhoodCancerResearch: function childhoodCancerResearch() {
      return {
        credentialLogo: null,
        descriptionText: o["default"].createElement(o["default"].Fragment, null, "hours of research funded since 2012 to accelerate the search for better treatments and cures for childhood cancer"),
        footerText: null,
        headingText: o["default"].createElement(o["default"].Fragment, null, "810K+"),
        headingTextAriaLabel: "More than eight hundred and ten thousand hours of research funded since 2012 to accelerate the search for better treatments and cures for childhood cancer",
        headingTextAssistiveSupplement: o["default"].createElement(o["default"].Fragment, null, " hours of research funded since 2012 to accelerate the search for better treatments and cures for childhood cancer"),
        isCitable: !1
      };
    },
    clientRetailInvestmentAssets: function clientRetailInvestmentAssets(e) {
      return {
        credentialLogo: null,
        descriptionText: o["default"].createElement(o["default"].Fragment, null, "In client retail investment assets held or under management by Northwestern Mutual Wealth Management.", u(e)),
        footerText: null,
        headingText: o["default"].createElement(o["default"].Fragment, null, "$281B"),
        headingTextAriaLabel: "Two hundred and eighty one billion dollars in client retail investment assets held or under management by Northwestern Mutual Wealth Management.",
        headingTextAssistiveSupplement: o["default"].createElement(o["default"].Fragment, null, " client retail investment assets held or under management by Northwestern Mutual Wealth Management."),
        isCitable: !0
      };
    },
    communityDonations: function communityDonations() {
      return {
        credentialLogo: null,
        descriptionText: o["default"].createElement(o["default"].Fragment, null, "donated to nonprofits through the Northwestern Mutual Foundation since its inception in 1992"),
        footerText: null,
        headingText: o["default"].createElement(o["default"].Fragment, null, "$500M+"),
        headingTextAriaLabel: "More than five hundred million dollars donated to nonprofits through the Northwestern Mutual Foundation since its inception in 1992",
        headingTextAssistiveSupplement: o["default"].createElement(o["default"].Fragment, null, " donated to nonprofits through the Northwestern Mutual Foundation since its inception in 1992"),
        isCitable: !1
      };
    },
    covidReliefDonations: function covidReliefDonations() {
      return {
        credentialLogo: null,
        descriptionText: o["default"].createElement(o["default"].Fragment, null, "in national COVID–19 relief"),
        footerText: null,
        headingText: o["default"].createElement(o["default"].Fragment, null, "$2M+"),
        headingTextAriaLabel: "More than two million dollars in national COVID&#8211;19 relief",
        headingTextAssistiveSupplement: o["default"].createElement(o["default"].Fragment, null, " in national COVID–19 relief"),
        isCitable: !1
      };
    },
    diDividendPayout: function diDividendPayout(e) {
      return {
        credentialLogo: null,
        descriptionText: o["default"].createElement(o["default"].Fragment, null, "in expected disability insurance dividends paid back to our policyowners in 2025", u(e)),
        footerText: o["default"].createElement(o["default"].Fragment, null, "Statistic for Northwestern Mutual, Dividends are reviewed annually and are not guaranteed.", " ", o["default"].createElement("cite", null, "based on Northwestern Mutual policyowner data.")),
        headingText: o["default"].createElement(o["default"].Fragment, null, "$570M"),
        headingTextAriaLabel: "Five hundred seventy million dollars in expected disability insurance dividends paid back to our policyowners",
        headingTextAssistiveSupplement: o["default"].createElement(o["default"].Fragment, null, " in expected disability insurance dividends paid back to our policyowners"),
        isCitable: !0
      };
    },
    financialStrengthRating: function financialStrengthRating(e) {
      return {
        credentialLogo: null,
        descriptionText: o["default"].createElement(o["default"].Fragment, null, "AAA, Aaa, and AA+—we've earned the highest financial strength ratings awarded to life insurers from all four major rating agencies.", u(e)),
        footerText: o["default"].createElement(o["default"].Fragment, null, "Awarded in the Insurance category: Life & Health industry,", " ", o["default"].createElement("cite", null, "Fortune® Magazine's annual survey, 2017")),
        headingText: o["default"].createElement(o["default"].Fragment, null, "A++"),
        headingTextAriaLabel: "A plus plus financial strength rating",
        headingTextAssistiveSupplement: o["default"].createElement(o["default"].Fragment, null, " financial strength rating"),
        isCitable: !0
      };
    },
    fitchRatings: function fitchRatings(e) {
      return {
        credentialLogo: null,
        descriptionText: o["default"].createElement(o["default"].Fragment, null, o["default"].createElement(l.TypographyComponent, {
          component: "span",
          uppercase: !0,
          block: !0,
          disableBottomPadding: !0,
          className: "nmx-block"
        }, "Highest"), o["default"].createElement(l.TypographyComponent, {
          component: "span",
          block: !0,
          disableBottomPadding: !0,
          className: "nmx-block"
        }, "Fitch Ratings", u(e)), o["default"].createElement(l.TypographyComponent, {
          component: "span",
          block: !0,
          disableBottomPadding: !0,
          className: "nmx-block"
        }, "January 2025"), " "),
        footerText: o["default"].createElement(o["default"].Fragment, null, o["default"].createElement("cite", null, "August 2023")),
        headingText: o["default"].createElement(o["default"].Fragment, null, "AAA"),
        headingTextAriaLabel: "Highest Fitch Ratings rating",
        headingTextAssistiveSupplement: o["default"].createElement(o["default"].Fragment, null, " Fitch Ratings rating"),
        isCitable: !0
      };
    },
    largestDirectProvider: function largestDirectProvider(e) {
      return {
        credentialLogo: null,
        descriptionText: o["default"].createElement(o["default"].Fragment, null, "Largest direct provider of individual life insurance in the U.S.", u(e)),
        footerText: o["default"].createElement(o["default"].Fragment, null, "Latest ranking for Northwestern Mutual based on direct premiums written", " ", o["default"].createElement("cite", null, "2019, S&P Global Market Intelligence")),
        headingText: o["default"].createElement(o["default"].Fragment, null, "No. 1"),
        headingTextAriaLabel: "Number one direct provider of individual life insurance in the U.S.",
        headingTextAssistiveSupplement: o["default"].createElement(o["default"].Fragment, null, " direct provider of individual life insurance in the U.S."),
        isCitable: !0
      };
    },
    milwaukeeNeighborhoodInvestments: function milwaukeeNeighborhoodInvestments() {
      return {
        credentialLogo: null,
        descriptionText: "invested in revitalizing underserved Milwaukee neighborhoods since 2013",
        footerText: null,
        headingText: o["default"].createElement(o["default"].Fragment, null, "$15M+"),
        headingTextAriaLabel: "More than fifteen million dollars invested in revitalizing underserved Milwaukee neighborhoods since 2013.",
        headingTextAssistiveSupplement: o["default"].createElement(o["default"].Fragment, null, " invested in revitalizing underserved Milwaukee neighborhoods since 2013"),
        isCitable: !1
      };
    },
    milwaukeeStudentInvestments: function milwaukeeStudentInvestments() {
      return {
        credentialLogo: null,
        descriptionText: o["default"].createElement(o["default"].Fragment, null, "invested in Milwaukee-area students over 25+ years"),
        footerText: null,
        headingText: o["default"].createElement(o["default"].Fragment, null, "$60M+"),
        headingTextAriaLabel: "More than sixty million dollars invested in Milwaukee area students over twenty five years.",
        headingTextAssistiveSupplement: o["default"].createElement(o["default"].Fragment, null, " invested in Milwaukee area students over twenty five plus years"),
        isCitable: !1
      };
    },
    milwaukeeStudentSupport: function milwaukeeStudentSupport() {
      return {
        credentialLogo: null,
        descriptionText: o["default"].createElement(o["default"].Fragment, null, "early childhood, K-12, and higher-education students supported in Milwaukee in 2024"),
        footerText: null,
        headingText: o["default"].createElement(o["default"].Fragment, null, "20K+"),
        headingTextAriaLabel: "More than twenty thousand early childhood, K&#45;12, and higher&#45;education students supported in Milwaukee in 2024.",
        headingTextAssistiveSupplement: o["default"].createElement(o["default"].Fragment, null, " early childhood, K-12, and higher-education students supported in Milwaukee in 2024"),
        isCitable: !1
      };
    },
    moodysInvestorsService: function moodysInvestorsService(e) {
      return {
        credentialLogo: null,
        descriptionText: o["default"].createElement(o["default"].Fragment, null, o["default"].createElement(l.TypographyComponent, {
          component: "span",
          uppercase: !0,
          block: !0,
          disableBottomPadding: !0,
          className: "nmx-block"
        }, "Highest"), o["default"].createElement(l.TypographyComponent, {
          component: "span",
          block: !0,
          disableBottomPadding: !0,
          className: "nmx-block"
        }, "Moody's Ratings", u(e)), o["default"].createElement(l.TypographyComponent, {
          component: "span",
          block: !0,
          disableBottomPadding: !0,
          className: "nmx-block"
        }, "August 2024")),
        footerText: o["default"].createElement(o["default"].Fragment, null, o["default"].createElement("cite", null, "November 2023")),
        headingText: o["default"].createElement(o["default"].Fragment, null, "Aaa"),
        headingTextAriaLabel: "Highest Moody&#39;s Investors Service rating",
        headingTextAssistiveSupplement: o["default"].createElement(o["default"].Fragment, null, " Moody's Investors Service rating"),
        isCitable: !0
      };
    },
    mostAdmired: function mostAdmired(e) {
      return {
        credentialLogo: null,
        descriptionText: o["default"].createElement(o["default"].Fragment, null, o["default"].createElement("strong", null, o["default"].createElement("em", null, "FORTUNE")), "® named us one of the World's Most Admired Life Insurance Companies, 2025", u(e)),
        footerText: o["default"].createElement(o["default"].Fragment, null, "Ranking for Northwestern Mutual, ", o["default"].createElement("cite", null, "2025 ", o["default"].createElement("strong", null, o["default"].createElement("em", null, "FORTUNE")), "®")),
        headingText: o["default"].createElement(o["default"].Fragment, null, "No. 1"),
        headingTextAriaLabel: "Number one most admired companies",
        headingTextAssistiveSupplement: o["default"].createElement(o["default"].Fragment, null, " most admired companies"),
        isCitable: !0
      };
    },
    mostTrustedFinancialCompaniesForLifeInsurance: function mostTrustedFinancialCompaniesForLifeInsurance(e) {
      return {
        credentialLogo: "ibd",
        descriptionText: o["default"].createElement(o["default"].Fragment, null, "Most Trusted Financial Companies for Life Insurance ranked by Investor's Business Daily, 2021", u(e)),
        footerText: o["default"].createElement(o["default"].Fragment, null, "Ranking for Northwestern Mutual", " ", o["default"].createElement("cite", null, "2021, Investor's Business Daily®")),
        headingText: o["default"].createElement(o["default"].Fragment, null, "No. 1"),
        headingTextAriaLabel: "Number one most trusted financial companies for life insurance",
        headingTextAssistiveSupplement: o["default"].createElement(o["default"].Fragment, null, " most trusted financial companies for life insurance"),
        isCitable: !0
      };
    },
    mostTrustedInsuranceCompany: function mostTrustedInsuranceCompany(e) {
      return {
        credentialLogo: "nerdwallet",
        descriptionText: o["default"].createElement(o["default"].Fragment, null, "Best Life Insurance Company ranked by NerdWallet, 2020", u(e)),
        footerText: o["default"].createElement(o["default"].Fragment, null, "Ranking for Northwestern Mutual Investment Services LLC,", " ", o["default"].createElement("cite", null, "©2017–2020 and TM, NerdWallet, Inc. All Rights Reserved.")),
        headingText: o["default"].createElement(o["default"].Fragment, null, "No. 1"),
        headingTextAriaLabel: "Number one most trusted insurance company",
        headingTextAssistiveSupplement: o["default"].createElement(o["default"].Fragment, null, " most trusted insurance company"),
        isCitable: !0
      };
    },
    numberOfClients: function numberOfClients(e) {
      return {
        credentialLogo: null,
        descriptionText: o["default"].createElement(o["default"].Fragment, null, "The number of people we're proud to call clients, and who put their trust in us.", u(e)),
        footerText: null,
        headingText: o["default"].createElement(o["default"].Fragment, null, "5.1M+"),
        headingTextAriaLabel: "Over five point one million Northwestern Mutual clients",
        headingTextAssistiveSupplement: o["default"].createElement(o["default"].Fragment, null, " clients at Northwestern Mutual"),
        isCitable: !1
      };
    },
    policyownerRetention: function policyownerRetention(e) {
      return {
        credentialLogo: null,
        descriptionText: o["default"].createElement(o["default"].Fragment, null, "The percentage of our policyowners who stay with us year over year.", u(e)),
        footerText: o["default"].createElement(o["default"].Fragment, null, "Statistic for Northwestern Mutual,", " ", o["default"].createElement("cite", null, "based on Northwestern Mutual policyowner data.")),
        headingText: o["default"].createElement(o["default"].Fragment, null, "97%"),
        headingTextAriaLabel: "Ninety seven percent of our clients stay with us year over year",
        headingTextAssistiveSupplement: o["default"].createElement(o["default"].Fragment, null, " of our clients stay with us year over year"),
        isCitable: !1
      };
    },
    rankedDisabilityIncomeInsurance: function rankedDisabilityIncomeInsurance(e) {
      return {
        credentialLogo: null,
        descriptionText: o["default"].createElement(o["default"].Fragment, null, "Top ranked for disability income insurance", u(e)),
        footerText: o["default"].createElement(o["default"].Fragment, null, "Latest ranking for Northwestern Mutual based on direct premiums earned", " ", o["default"].createElement("cite", null, "S&P Global Market Intelligence")),
        headingText: o["default"].createElement(o["default"].Fragment, null, "No. 1"),
        headingTextAriaLabel: "Top ranked for disability income insurance",
        headingTextAssistiveSupplement: o["default"].createElement(o["default"].Fragment, null, " ranked for disability income insurance"),
        isCitable: !0
      };
    },
    rankedInsuranceCompany: function rankedInsuranceCompany(e) {
      return {
        credentialLogo: "nerdwallet",
        descriptionText: o["default"].createElement(o["default"].Fragment, null, "Best life insurance company for consumer experience, 2023", u(e)),
        footerText: o["default"].createElement(o["default"].Fragment, null, "Ranking for Northwestern Mutual Investment Services LLC,", " ", o["default"].createElement("cite", null, "©2017–2024 and TM, NerdWallet, Inc. All Rights Reserved.")),
        headingText: o["default"].createElement(o["default"].Fragment, null, "No. 1"),
        headingTextAriaLabel: "Number one ranked insurance company for consumer experience",
        headingTextAssistiveSupplement: o["default"].createElement(o["default"].Fragment, null, " ranked insurance company for consumer experience"),
        isCitable: !0
      };
    },
    rankedInvestmentService: function rankedInvestmentService(e) {
      return {
        credentialLogo: null,
        descriptionText: o["default"].createElement(o["default"].Fragment, null, "We're one of the top U.S. Independent Investment Broker-Dealers.", u(e)),
        footerText: o["default"].createElement(o["default"].Fragment, null, "Ranking for Northwestern Mutual Investment Services LLC,", " ", o["default"].createElement("cite", null, "Financial Advisor magazine and InvestmentNews, April 2021")),
        headingText: o["default"].createElement(o["default"].Fragment, null, "Top 5"),
        headingTextAriaLabel: "Top five ranked investment service",
        headingTextAssistiveSupplement: o["default"].createElement(o["default"].Fragment, null, " ranked investment service"),
        isCitable: !0
      };
    },
    sAndPGlobalRatings: function sAndPGlobalRatings(e) {
      return {
        credentialLogo: null,
        descriptionText: o["default"].createElement(o["default"].Fragment, null, o["default"].createElement(l.TypographyComponent, {
          component: "span",
          uppercase: !0,
          block: !0,
          disableBottomPadding: !0,
          className: "nmx-block"
        }, "Second Highest"), o["default"].createElement(l.TypographyComponent, {
          component: "span",
          block: !0,
          disableBottomPadding: !0,
          className: "nmx-block"
        }, "S&P Global Ratings", u(e)), o["default"].createElement(l.TypographyComponent, {
          component: "span",
          block: !0,
          disableBottomPadding: !0,
          className: "nmx-block"
        }, "April 2024")),
        footerText: o["default"].createElement(o["default"].Fragment, null, o["default"].createElement("cite", null, "May 2023")),
        headingText: o["default"].createElement(o["default"].Fragment, null, "AA+"),
        headingTextAriaLabel: "Second Highest Moody&#39;s Investors Service rating",
        headingTextAssistiveSupplement: o["default"].createElement(o["default"].Fragment, null, " Moody's Investors Service rating"),
        isCitable: !0
      };
    },
    totalDividendPayout: function totalDividendPayout(e) {
      return {
        credentialLogo: null,
        descriptionText: o["default"].createElement(o["default"].Fragment, null, "in dividends expected to be paid in 2025", u(e)),
        footerText: o["default"].createElement(o["default"].Fragment, null, "Statistic for Northwestern Mutual, Dividends are reviewed annually and are not guaranteed.", " ", o["default"].createElement("cite", null, "based on Northwestern Mutual policyowner data.")),
        headingText: o["default"].createElement(o["default"].Fragment, null, "$8.2B"),
        headingTextAriaLabel: "Eight point two billion dollars in dividends expected to be paid in 2025",
        headingTextAssistiveSupplement: o["default"].createElement(o["default"].Fragment, null, " in dividends expected to be paid in 2025"),
        isCitable: !0
      };
    },
    yearsOfService: function yearsOfService(e) {
      return {
        credentialLogo: null,
        descriptionText: o["default"].createElement(o["default"].Fragment, null, "The number of years we’ve been there for our clients—through depressions, downturns, and pandemics.", u(e)),
        footerText: null,
        headingText: o["default"].createElement(o["default"].Fragment, null, "168+"),
        headingTextAriaLabel: "More than one hundred sixty&#45;eight years strong through depressions, downturns, and pandemics",
        headingTextAssistiveSupplement: o["default"].createElement(o["default"].Fragment, null, " years strong through depressions, downturns, and pandemics"),
        isCitable: !1
      };
    }
  },
  c = function c(e) {
    var t = e.accentOrientation,
      n = e.accentColorVariant,
      l = e.additionalDescription,
      r = e.backgroundVariant,
      i = e.branding,
      d = e.className,
      u = e.credential,
      c = e.descriptionTextAlign,
      m = e.hasAccent,
      f = e.headingColorVariant,
      g = e.headingTextUpperCase,
      p = e.themeType,
      h = e.sup1,
      T = e.sup2,
      b = s[u](h, T, p),
      x = {
        additionalDescription: l,
        credential: u,
        descriptionText: b.descriptionText,
        footerText: b.footerText,
        headingText: b.headingText,
        headingTextAriaLabel: b.headingTextAriaLabel,
        headingTextAssistiveSupplement: b.headingTextAssistiveSupplement,
        isCitable: b.isCitable,
        logo: b.credentialLogo,
        sup1: h,
        sup2: T
      };
    return o["default"].createElement(a.CredentialCardContent, {
      content: x,
      accentOrientation: t,
      accentColorVariant: n,
      backgroundVariant: r,
      branding: i,
      className: d,
      descriptionTextAlign: c,
      hasAccent: m,
      headingColorVariant: f,
      headingTextUpperCase: g,
      themeType: p
    });
  };
c.propTypes = {
  accentColorVariant: d["default"].oneOf(["gold", "sky"]),
  additionalDescription: d["default"].any,
  accentOrientation: d["default"].oneOf(["horizontal", "vertical"]),
  backgroundVariant: d["default"].oneOf(["darkDefault", "lightA", "lightB", "lightC"]),
  branding: d["default"].oneOf(["nm", "pcg"]),
  className: d["default"].string,
  credential: d["default"].oneOf(["amBestCompany", "blackFounderAcceleratorProgram", "blackImpactInvestingFund", "blackStartStartUpCompanyDonations", "childhoodCancerDonations", "childhoodCancerResearch", "clientRetailInvestmentAssets", "communityDonations", "covidReliefDonations", "diDividendPayout", "financialStrengthRating", "fitchRatings", "largestDirectProvider", "milwaukeeNeighborhoodInvestments", "milwaukeeStudentInvestments", "milwaukeeStudentSupport", "moodysInvestorsService", "mostAdmired", "mostTrustedFinancialCompaniesForLifeInsurance", "mostTrustedInsuranceCompany", "numberOfClients", "policyownerRetention", "rankedDisabilityIncomeInsurance", "rankedInsuranceCompany", "rankedInvestmentService", "sAndPGlobalRatings", "totalDividendPayout", "yearsOfService"]).isRequired,
  descriptionTextAlign: d["default"].oneOf(["inherit", "left", "center", "right"]),
  hasAccent: d["default"].bool,
  headingColorVariant: d["default"].oneOf(["default", "sky"]),
  headingTextUpperCase: d["default"].bool,
  sup1: d["default"].any,
  sup2: d["default"].any,
  themeType: d["default"].oneOf(["lightTheme", "darkTheme"])
}, c.defaultProps = {
  accentOrientation: "vertical",
  accentColorVariant: "gold",
  backgroundVariant: "lightB",
  branding: "nm",
  hasAccent: !1,
  headingColorVariant: "default",
  headingTextUpperCase: !1,
  themeType: "lightTheme"
};
var m = function m(t) {
  var l = t.accentColorVariant,
    r = t.accentOrientation,
    i = t.backgroundVariant,
    d = t.branding,
    u = t.className,
    m = t.credentials,
    f = t.descriptionTextAlign,
    g = t.hasAccent,
    p = t.headingColorVariant,
    h = t.headingTextUpperCase,
    T = t.themeType;
  e.useEffect(function () {
    0 === m.length && console.error("Missing credentials. At least one credential is required.");
    for (var e = 0; e < m.length; e += 1) m[e].credential in s ? s[m[e].credential]().isCitable && !m[e].sup1 && console.error("".concat(m[e], " credential requires a sup to be passed in for footer reference.")) : console.error("Provided credential identifier is invalid. Possible credentials are [amBestCompany, blackFounderAcceleratorProgram, blackImpactInvestingFund, blackStartStartUpCompanyDonations, childhoodCancerDonations, childhoodCancerResearch, clientRetailInvestmentAssets, communityDonations, covidReliefDonations, diDividendPayout, financialStrengthRating, fitchRatings, largestDirectProvider, milwaukeeNeighborhoodInvestments, milwaukeeStudentInvestments, milwaukeeStudentSupport, moodysInvestorsService, mostAdmired, mostTrustedFinancialCompaniesForLifeInsurance, mostTrustedInsuranceCompany, numberOfClients, policyownerRetention, rankedDisabilityIncomeInsurance, rankedInsuranceCompany, rankedInvestmentService, sAndPGlobalRatings, totalDividendPayout, yearsOfService].");
  }, []);
  var b = 12 / m.length,
    x = 4 === m.length ? 6 : 4;
  return o["default"].createElement(n.Row, {
    className: u,
    align: "center"
  }, m.map(function (e, t) {
    return o["default"].createElement(a.CredentialCardColStyled, {
      key: "credential-".concat(t + 1),
      medium: x,
      large: b
    }, o["default"].createElement(c, {
      className: "nmx-credential-card",
      accentColorVariant: l,
      accentOrientation: r,
      additionalDescription: e.additionalDescription,
      backgroundVariant: i,
      branding: d,
      credential: e.credential,
      descriptionTextAlign: f,
      hasAccent: g,
      headingColorVariant: p,
      headingTextUpperCase: h,
      sup1: e.sup1,
      sup2: e.sup2,
      themeType: T
    }));
  }));
};
m.propTypes = {
  accentColorVariant: d["default"].oneOf(["gold", "sky"]),
  accentOrientation: d["default"].oneOf(["horizontal", "vertical"]),
  backgroundVariant: d["default"].oneOf(["darkDefault", "lightA", "lightB", "lightC"]),
  branding: d["default"].oneOf(["nm", "pcg"]),
  className: d["default"].string,
  credentials: d["default"].arrayOf(d["default"].shape({
    additionalDescription: d["default"].any,
    credential: d["default"].oneOf(["amBestCompany", "blackFounderAcceleratorProgram", "blackImpactInvestingFund", "blackStartStartUpCompanyDonations", "childhoodCancerDonations", "childhoodCancerResearch", "clientRetailInvestmentAssets", "communityDonations", "covidReliefDonations", "diDividendPayout", "financialStrengthRating", "fitchRatings", "largestDirectProvider", "milwaukeeNeighborhoodInvestments", "milwaukeeStudentInvestments", "milwaukeeStudentSupport", "moodysInvestorsService", "mostAdmired", "mostTrustedFinancialCompaniesForLifeInsurance", "mostTrustedInsuranceCompany", "numberOfClients", "policyownerRetention", "rankedDisabilityIncomeInsurance", "rankedInsuranceCompany", "rankedInvestmentService", "sAndPGlobalRatings", "totalDividendPayout", "yearsOfService"]).isRequired,
    sup1: d["default"].any,
    sup2: d["default"].any
  })).isRequired,
  descriptionTextAlign: d["default"].oneOf(["inherit", "left", "center", "right"]),
  headingColorVariant: d["default"].oneOf(["default", "sky"]),
  headingTextUpperCase: d["default"].bool,
  themeType: d["default"].oneOf(["lightTheme", "darkTheme", "nmx-pcg"])
}, m.defaultProps = {
  accentOrientation: "vertical",
  accentColorVariant: "gold",
  backgroundVariant: "lightB",
  branding: "nm",
  hasAccent: !1,
  headingColorVariant: "default",
  headingTextUpperCase: !1,
  themeType: "lightTheme"
}, exports.CredentialCardComponent = c, exports.CredentialCardSetComponent = m;